<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="currentColor"
    :width="width"
    :height="height"
  >
    <path d="M26 5H6C5.20435 5 4.44129 5.31607 3.87868 5.87868C3.31607 6.44129 3 7.20435 3 8V22C3 22.7956 3.31607 23.5587 3.87868 24.1213C4.44129 24.6839 5.20435 25 6 25H15V27H12C11.7348 27 11.4804 27.1054 11.2929 27.2929C11.1054 27.4804 11 27.7348 11 28C11 28.2652 11.1054 28.5196 11.2929 28.7071C11.4804 28.8946 11.7348 29 12 29H20C20.2652 29 20.5196 28.8946 20.7071 28.7071C20.8946 28.5196 21 28.2652 21 28C21 27.7348 20.8946 27.4804 20.7071 27.2929C20.5196 27.1054 20.2652 27 20 27H17V25H26C26.7956 25 27.5587 24.6839 28.1213 24.1213C28.6839 23.5587 29 22.7956 29 22V8C29 7.20435 28.6839 6.44129 28.1213 5.87868C27.5587 5.31607 26.7956 5 26 5ZM6 7H26C26.2652 7 26.5196 7.10536 26.7071 7.29289C26.8946 7.48043 27 7.73478 27 8V18H5V8C5 7.73478 5.10536 7.48043 5.29289 7.29289C5.48043 7.10536 5.73478 7 6 7ZM26 23H6C5.73478 23 5.48043 22.8946 5.29289 22.7071C5.10536 22.5196 5 22.2652 5 22V20H27V22C27 22.2652 26.8946 22.5196 26.7071 22.7071C26.5196 22.8946 26.2652 23 26 23Z" />
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: [Number, String],
      default: 32,
    },
    height: {
      type: [Number, String],
      default: 32,
    },
  },
}
</script>

